import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const sendToNextLevelApprover = createApi(`SendToNextLevelSlice`,"POST");

const SendToNextLevelSlice = createSlice({
  name: 'SendToNextLevelSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendToNextLevelApprover.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendToNextLevelApprover.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(sendToNextLevelApprover.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SendToNextLevelSlice.reducer;